import Page from 'common/components/page/Page';
import { PageTemplates } from 'common/components/page/PageTemplates';
import useTypedSelector from 'common/hooks/useTypedSelector';
import FetchStatus from 'common/types/FetchStatus';
import React from 'react';
import styles from './Home.module.scss';
import SplashCtaCard from './HomeCtaCard';

const Splash = () => {
  const { authenticated } = useTypedSelector((state) => ({
    authenticated:
      state.auth.fetchStatus === FetchStatus.loaded &&
      state.auth.access_token !== null,
  }));
  return (
    <Page template={PageTemplates.fullWidth}>
      <div className='cds-hero'>
        <div className='cds-hero-heading'>
          <h1 className='mb-0'>Welcome to</h1>
          <b>
            <span className={styles.red}>Chicago&apos;s</span> Shared Housing
            Registration Portal
          </b>
        </div>
      </div>
      <div className={styles.wrapper}>
        <SplashCtaCard
          title={['FAQ']}
          subtitle='Frequently Asked Questions'
          description='Please click here to visit our FAQ page.'
          href='/static-pages/faq'
        />
        {!authenticated && (
          <SplashCtaCard
            title={['Log In /', 'Create an Account']}
            subtitle='Log In/Create an Account'
            description='Please click here to log in or create a new account.'
            href='/auth/login'
          />
        )}
        {authenticated && (
          <SplashCtaCard
            title={['Dashboard']}
            subtitle='Dashboard'
            description='Please click here to view your dashboard.'
            href='/dashboard'
          />
        )}
        <SplashCtaCard
          title={['Contact']}
          subtitle='Business Affairs and Consumer Protection'
          description='Please click here to contact BACP.'
          href='/static-pages/contact'
        />
      </div>
    </Page>
  );
};

export default Splash;
